import { Column, Table } from "@tanstack/react-table"
import { ChevronsUpDown, SortAsc, SortDesc } from "lucide-react"

interface DataTableColumnHeaderProps<TData, TValue>
    extends React.HTMLAttributes<HTMLDivElement> {
    column: Column<TData, TValue>
    title: string,
    table: Table<TData>,
}

export function DataTableColumnHeader<TData, TValue>({
    column,
    title,
    table
}: DataTableColumnHeaderProps<TData, TValue>) {

    if (!column.getCanSort()) {
        return <div className="table__header-cell">{title}</div>
    }

    return (

        <div className="table__header-option-container">
            <button className="table__header-sort-button" onClick={() => {
                table.toggleAllPageRowsSelected(false);
                const sort = column.getIsSorted();
                if (!sort) column.toggleSorting(false);
                if (sort === "asc") column.toggleSorting(true);
                else column.toggleSorting(false);
            }}>
                <span className="table__header-text">{title}</span>
                {column.getIsSorted() === "desc" ? (
                    <SortDesc width={14} height={14} />
                ) : column.getIsSorted() === "asc" ? (
                    <SortAsc width={14} height={14} />
                ) : (
                    <ChevronsUpDown width={14} height={14} />
                )}
            </button>
        </div>
    )
}